import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import './Createtemplate.scss'

interface modalTypes {
  show: boolean
  handleClose: () => void
}

const CreateTemplateModal = ({show, handleClose}: modalTypes) => {
  const navigate = useNavigate()
  const [scratchTemplate, setScratchTemplate] = useState<any>(true)
  const [ourTemplate, setOurTemplate] = useState<any>(false)
  const [value, setValue] = useState<any>('blank')

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-480px h-200px'
        show={show}
        onHide={handleClose}
      >
        <div className=''>
          <div className='modal-header'>
            <h2>New Template</h2>
            <div className='btn btn-icon btn-sm ' onClick={handleClose}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
            </div>
          </div>
          <div className='modal-body p-16'>
            <div className='row d-flex justify-content-center'>
              <div onDoubleClick={() => navigate('/New-Template')} className='col-6'>
                <input
                  type='radio'
                  className='btn-check'
                  name='radio_buttons_2'
                  value='blank'
                  id='blank_radio'
                  checked={scratchTemplate && value === 'blank'}
                  onChange={(e) => {
                    setValue(e.target.value)
                    setScratchTemplate(!scratchTemplate)
                    setOurTemplate(false)
                  }}
                />
                <label
                  className='modal-boxbtn btn btn-outline btn-outline-dashed btn-outline-default py-10 d-flex align-items-center d-flex flex-column'
                  htmlFor='blank_radio'
                >
                  {/* <span className='svg-icon svg-icon-4x ms-3 mb-5'>
                    <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                  </span> */}
                  <button
                    className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2 rounded-circle'
                    style={{width: '59px', height: '59px'}}
                  >
                    <KTSVG
                      className='svg-icon-3x w-75'
                      path='/media/icons/duotune/abstract/note.svg'
                    />
                  </button>
                  <span className='d-block fw-bold text-center'>
                    <span className='text-muted fw-bold fs-6'>Start from Scratch </span>
                  </span>
                </label>
              </div>
              {/* <div onDoubleClick={() => navigate('/our-template')} className='col-6'>
                <input
                  type='radio'
                  className='btn-check'
                  name='radio_buttons_2'
                  value='ourTemplates'
                  id='our_radio'
                  checked={ourTemplate}
                  onChange={(e) => {
                    setValue(e.target.value)
                    setOurTemplate(!ourTemplate)
                    setScratchTemplate(false)
                  }}
                />
                <label
                  className='modal-boxbtn btn btn-outline btn-outline-dashed btn-outline-default p-10 d-flex align-items-center d-flex flex-column'
                  htmlFor='our_radio'
                >
                  <button
                    className='btn btn-sm btn-icon btn-light btn-active-light-primary rounded-circle'
                    style={{width: '59px', height: '59px'}}
                  >
                    <KTSVG
                      className='svg-icon-3x'
                      path='/media/icons/duotune/abstract/note-2.svg'
                    />
                  </button>
                  <span className='d-block fw-bold text-center'>
                    <span className='text-muted fw-bold fs-6'>Choose from our templates</span>
                  </span>
                </label>
              </div> */}
            </div>
            <div className='d-flex  align-items-end justify-content-center mt-10'>
              <Link to={value === 'blank' ? '/New-Template' : '/our-template'}>
                <button type='submit' className='btn btn-lg btn-primary me-3 mt-3 w-150px'>
                  <span className='indicator-label'>Next</span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateTemplateModal
